import { useContext, useRef, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import { useSelector, useDispatch } from "react-redux";
import ImagePreview from "../components/ImagePreview";
import { dataURItoBlob, errorResponseMessage } from "./const.prop";
import { validateFile } from "../../utils/application-helper";
import { updateProfileImage, getuserInfo } from "../store/actions/userActions";
import { AuthContext } from "../contexts/AuthContext";

const AddProfilePhoto = () => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const inputRef = useRef();
  const [loadedImage, setLoadedImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [cropEnabled, setCropEnabled] = useState(false);
  const [ext, setExt] = useState("");
  const triggerInputClick = () => inputRef.current.click();
  let dataURL = null;

  const imageChangeHandler = () => {
    const file = inputRef.current.files[0];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    setExt(fileExtension);
    const validationRes = validateFile(file, "image");
    if (validationRes.errors.length) {
      appContext.updateNotificationState({
        type: "error",
        message: validationRes.errors[0],
        show: true,
      });
      return;
    }
    setLoadedImage(URL.createObjectURL(file));
  };
  const getCroppedImage = (croppedImage) => setCroppedImage(croppedImage);

  const successCallback = () => {
    dispatch(getuserInfo());
    // appContext.updateNotificationState({
    //   type: "success",
    //   message: "Profile image updated successfully",
    //   show: true,
    // });
    appContext.updateModalState();
  };

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    appContext.updateNotificationState({
      show: true,
      type: "error",
      message: e?.response?.data?.message,
    });
    appContext.updateModalState();
  };

  const postHandler = () => {
    if (cropEnabled === false) {
      fetch(loadedImage)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            dataURL = reader.result;
            profileImageHandler();
          };
          reader.readAsDataURL(blob);
        })
        .catch((error) => console.error("Error fetching blob:", error));
    } else {
      profileImageHandler();
    }
  };

  const profileImageHandler = () => {
    appContext.updateLoaderState(true);
    const formData = new FormData();
    if (cropEnabled) {
      formData.append("image", dataURItoBlob(croppedImage));
    } else {
      formData.append("image", dataURItoBlob(dataURL));
    }
    dispatch(
      updateProfileImage(
        {
          "profile-picture": formData,
        },
        successCallback,
        failureCallback
      )
    );
  };
  return (
    <>
      <div className="modal-body">
        <div className="card card-modal">
          <div className="d-flex align-items-center justify-content-center height-inherit cursor-pointer">
            {!loadedImage && (
              <p
                className="file text-center img-txt"
                onClick={triggerInputClick}
              >
                Select profile image to upload
              </p>
            )}
          </div>
          <div>
            {loadedImage && (
              <ImagePreview
                imageSrc={loadedImage}
                cropImageHandler={getCroppedImage}
                cropEnabled={cropEnabled}
              />
            )}
          </div>
        </div>
        <div className="d-flex mt-3 cursor-pointer">
          <span className="crop-btn" onClick={() => setCropEnabled(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="26"
              viewBox="0 0 24 26"
              fill="none"
            >
              <path
                d="M22 19.7666C22 19.9807 21.921 20.1862 21.7803 20.3376C21.6397 20.489 21.4489 20.5741 21.25 20.5741H18.25V23.8044C18.25 24.0186 18.171 24.224 18.0303 24.3755C17.8897 24.5269 17.6989 24.612 17.5 24.612C17.3011 24.612 17.1103 24.5269 16.9697 24.3755C16.829 24.224 16.75 24.0186 16.75 23.8044V20.5741H5.5C5.30109 20.5741 5.11032 20.489 4.96967 20.3376C4.82902 20.1862 4.75 19.9807 4.75 19.7666V7.653H1.75C1.55109 7.653 1.36032 7.56791 1.21967 7.41646C1.07902 7.26502 1 7.05961 1 6.84543C1 6.63124 1.07902 6.42584 1.21967 6.27439C1.36032 6.12294 1.55109 6.03786 1.75 6.03786H4.75V2.80757C4.75 2.59339 4.82902 2.38798 4.96967 2.23653C5.11032 2.08508 5.30109 2 5.5 2C5.69891 2 5.88968 2.08508 6.03033 2.23653C6.17098 2.38798 6.25 2.59339 6.25 2.80757V18.959H21.25C21.4489 18.959 21.6397 19.0441 21.7803 19.1955C21.921 19.347 22 19.5524 22 19.7666ZM8.5 7.653H16.75V16.5363C16.75 16.7505 16.829 16.9559 16.9697 17.1073C17.1103 17.2588 17.3011 17.3438 17.5 17.3438C17.6989 17.3438 17.8897 17.2588 18.0303 17.1073C18.171 16.9559 18.25 16.7505 18.25 16.5363V6.84543C18.25 6.63124 18.171 6.42584 18.0303 6.27439C17.8897 6.12294 17.6989 6.03786 17.5 6.03786H8.5C8.30109 6.03786 8.11032 6.12294 7.96967 6.27439C7.82902 6.42584 7.75 6.63124 7.75 6.84543C7.75 7.05961 7.82902 7.26502 7.96967 7.41646C8.11032 7.56791 8.30109 7.653 8.5 7.653Z"
                fill="black"
                fillOpacity="0.6"
              />
            </svg>
          </span>
          {/* <span className="crop-txt ml-2">
                (300px 100px) or (600px 200px)
              </span> */}
        </div>
        <input
          className="d-none"
          onChange={imageChangeHandler}
          type="file"
          ref={inputRef}
        />
      </div>
      <div className="modal-footer mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={postHandler}
          className="btn btn-outline-primary modal-btn"
          disabled={!loadedImage}
        >
          Done
        </button>
      </div>
    </>
  );
};

export default AddProfilePhoto;
